import { OnBehalfProject } from './on-behalf-projects.model';

export function transformOnBehalfProjects(
  onBehalfProject: OnBehalfProject,
): OnBehalfProject {
  return onBehalfProject;
}
